<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { DropdownMenuItemEmits, DropdownMenuItemProps } from 'reka-ui'

import { cn } from 'cn'
import { DropdownMenuItem, useForwardPropsEmits } from 'reka-ui'

import type { DropdownMenuItemVariants } from './variants'

import { dropdownMenuItemVariants } from './variants'

const props = withDefaults(defineProps<DropdownMenuItemProps & {
  class?: HTMLAttributes['class']
  inset?: boolean
  color?: 'destructive' | 'default'
  iconLeading?: string
  iconTrailing?: string
  iconClass?: HTMLAttributes['class']
  variant?: DropdownMenuItemVariants['variant']
}>(), {
  color: 'default',
  variant: 'solid',
})

const emits = defineEmits<DropdownMenuItemEmits>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
const iconClass = 'size-[16px]'
</script>

<template>
  <DropdownMenuItem
    v-bind="forwarded"
    :class="cn(
      dropdownMenuItemVariants({ color, variant }),
      inset && 'pl-8',
      props.class,
    )"
  >
    <UiIcon
      v-if="iconLeading"
      :name="iconLeading"
      :class="cn(props.iconClass, iconClass)"
    />
    <slot />
    <UiIcon
      v-if="iconTrailing"
      :name="iconTrailing"
      :class="cn(props.iconClass, iconClass)"
    />
  </DropdownMenuItem>
</template>
